/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentGrid200,
  GetApiV1CourseregistrationEnrollmentGrid401,
  GetApiV1CourseregistrationEnrollmentGrid500,
  GetApiV1CourseregistrationEnrollmentGridQueryParams,
  GetApiV1CourseregistrationEnrollmentGridQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGrid.ts";
import { courseRegistrationEnrollmentParentViewModelSchema } from "../courseRegistrationEnrollmentParentViewModelSchema.ts";
import { eCompanyFilterTypeSchema } from "../eCompanyFilterTypeSchema.ts";
import { eDocumentSelectFilterSchema } from "../eDocumentSelectFilterSchema.ts";

export const getApiV1CourseregistrationEnrollmentGridQueryParamsSchema = z
  .object({
    Filter: z.optional(
      z
        .lazy(() => eCompanyFilterTypeSchema)
        .describe("1 = Main | 2 = Company | 3 = All | "),
    ),
    CompanyId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "ID da empresa para filtrar as matrículas. Obrigatório quando Filter = Company. Opcional.",
        ),
    ),
    CourseRegistrationId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "ID de uma matrícula específica para filtrar. Use 0 para não filtrar.",
        ),
    ),
    PoleId: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "ID do polo. Use -1 para filtrar matrículas sem polo (Pecege Online). Use 0 para não filtrar.",
        ),
    ),
    CourseNames: z.optional(
      z
        .string()
        .describe(
          "IDs de curso separados por vírgula, podendo conter o prefixo 'GRP' (ex.: 'GRP1,GRP2'). Opcional.",
        ),
    ),
    StudentName: z.optional(
      z
        .string()
        .describe(
          "Nome do aluno ou IDs de pessoa separados por vírgula com prefixo 'USR' (ex.: 'USR10,USR20'). Opcional.",
        ),
    ),
    Status: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "Status da matrícula para filtrar. Use 0 para retornar todos (exceto PaymentSelection). Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
        ),
    ),
    Documents: z.optional(
      z
        .lazy(() => eDocumentSelectFilterSchema)
        .describe("0 = All | 1 = WithDocuments | 2 = WithoutDocuments | "),
    ),
    DocumentStartDate: z.optional(
      z
        .string()
        .datetime()
        .describe(
          "Data de início do intervalo para filtro por data do documento (formato: yyyy-MM-dd). Opcional.",
        ),
    ),
    DocumentEndDate: z.optional(
      z
        .string()
        .datetime()
        .describe(
          "Data de término do intervalo para filtro por data do documento (formato: yyyy-MM-dd). Opcional.",
        ),
    ),
    Email: z.optional(
      z
        .string()
        .describe("E-mail do aluno para filtrar as matrículas. Opcional."),
    ),
    Cpf: z.optional(
      z
        .string()
        .describe(
          "CPF do aluno, com ou sem máscara, para filtrar as matrículas. Opcional.",
        ),
    ),
    Page: z.optional(
      z.coerce
        .number()
        .int()
        .describe("Número da página para paginação. Padrão: 1."),
    ),
    PageSize: z.optional(
      z.coerce
        .number()
        .int()
        .describe("Quantidade de registros por página. Padrão: 20."),
    ),
  })
  .optional() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentGrid200Schema = z.array(
  z.lazy(() => courseRegistrationEnrollmentParentViewModelSchema),
) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGrid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGrid500>;

export const getApiV1CourseregistrationEnrollmentGridQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationEnrollmentGrid200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentGridQueryResponse>;
